export interface Hook<Args extends Array<any> = []> {
    listeners: Listener<Args>[];
    fire(...args: Args): void;
    add(listener: Listener<Args>): void;
}

export interface Listener<Args extends Array<any> = []> {
    onFire(...args: Args): void;
    remove(): void;
    removed: boolean;
}

export function createHook<Args extends Array<any> = []>(): Hook<Args> {
    return {
        listeners: [],
        fire(...args: Args) {
            for (const listener of this.listeners) {
                listener.onFire(...args);
            }
        },
        add(listener) {
            this.listeners.push(listener);
            listener.removed = false;
        },
    };
}

export function addListener<Args extends Array<any> = []>(
    hook: Hook<Args>,
    onFire: (...args: Args) => void
): Listener<Args> {
    const listener: Listener<Args> = {
        onFire,
        remove() {
            if (this.removed) return;
            const index = hook.listeners.indexOf(listener);
            if (index !== -1) {
                hook.listeners.splice(index, 1);
            }
            this.removed = true;
        },
        removed: false,
    };
    hook.add(listener);
    return listener;
}
